<skl-icon
    shape="circle"
    [tooltip]="{
        text: statusInfo.tooltip,
        color: statusInfo.color
    }"
    [color]="statusInfo.color"
    [innerColor]="statusInfo.innerColor"
    [name]="statusInfo.name">
</skl-icon>
